import api from '../Utils/api'

export const fetchAllTasks = async (tag) => {
  const apiResponse = await api(
    'GET',
    `task-app?tag=${tag && tag !== null ? tag : ''}`,
    null
  )
  return apiResponse
}

export const fetchAssigneeList = async () => {
  const apiResponse = await api('GET', 'users/all', null)
  return apiResponse
}

export const fetchTagsList = async () => {
  const apiResponse = await api('GET', 'tags/all', null)
  return apiResponse
}
